import { CumulativeReportFilterValues } from 'pages/Finance/CumulativeReport/CumulativeReportFilter';
import { ExpandIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { formatRangeInputInTz } from 'utils/date';

import { StyledCumulativeReportPeriod } from './CumulativeReportDatagrid.styled';

type CumulativeReportPeriodProps = {
  filters: CumulativeReportFilterValues;
  toggleIsOpen: () => void;
  isOpen: boolean;
};

export const CumulativeReportDatagridPeriod: React.FC<CumulativeReportPeriodProps> = ({
  filters,
  toggleIsOpen,
  isOpen,
}) => {
  const alertText = `Нарастающий итог по счетам за период ${formatRangeInputInTz(
    [filters?.periodFrom, filters?.periodTo],
    {
      timezone: filters?.timezone,
      format: 'dd.MM.yyyy',
    },
  )}`;

  return (
    <StyledCumulativeReportPeriod isOpen={isOpen}>
      <Typography variant="h6">{alertText}</Typography>
      <ExpandIconButton isExpanded={isOpen} onClick={toggleIsOpen} />
    </StyledCumulativeReportPeriod>
  );
};
